/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SiteSessionSummary
 */
export interface SiteSessionSummary {
    /**
     * The device group tag for this site
     * @type {string}
     * @memberof SiteSessionSummary
     */
    deviceGroupTag?: string;
    /**
     * The site name
     * @type {string}
     * @memberof SiteSessionSummary
     */
    siteName?: string;
    /**
     * Number of chargers at this site
     * @type {number}
     * @memberof SiteSessionSummary
     */
    chargerCount?: number;
    /**
     * Total number of charging sessions
     * @type {number}
     * @memberof SiteSessionSummary
     */
    sessionCount?: number;
    /**
     * Total energy delivered in Wh
     * @type {number}
     * @memberof SiteSessionSummary
     */
    energyWh?: number;
    /**
     * Charging success rate as a percentage (0-100)
     * @type {number}
     * @memberof SiteSessionSummary
     */
    chargingSuccessRate?: number;
    /**
     * The device group tag for the parent organisation
     * @type {string}
     * @memberof SiteSessionSummary
     */
    orgGroupTag?: string;
    /**
     * The parent organisation name
     * @type {string}
     * @memberof SiteSessionSummary
     */
    orgName?: string;
}

/**
 * Check if a given object implements the SiteSessionSummary interface.
 */
export function instanceOfSiteSessionSummary(
    value: object,
): value is SiteSessionSummary {
    return true;
}

export function SiteSessionSummaryFromJSON(json: any): SiteSessionSummary {
    return SiteSessionSummaryFromJSONTyped(json, false);
}

export function SiteSessionSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SiteSessionSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        chargerCount:
            json["chargerCount"] == null ? undefined : json["chargerCount"],
        sessionCount:
            json["sessionCount"] == null ? undefined : json["sessionCount"],
        energyWh: json["energyWh"] == null ? undefined : json["energyWh"],
        chargingSuccessRate:
            json["chargingSuccessRate"] == null
                ? undefined
                : json["chargingSuccessRate"],
        orgGroupTag:
            json["orgGroupTag"] == null ? undefined : json["orgGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
    };
}

export function SiteSessionSummaryToJSON(
    value?: SiteSessionSummary | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        siteName: value["siteName"],
        chargerCount: value["chargerCount"],
        sessionCount: value["sessionCount"],
        energyWh: value["energyWh"],
        chargingSuccessRate: value["chargingSuccessRate"],
        orgGroupTag: value["orgGroupTag"],
        orgName: value["orgName"],
    };
}
